<template>
  <PageHeader title="Select items to Make payment"  v-if="customerUuid"  >
    <v-row no-gutters >
       <div v-if="orders.length==0" class="pa-4">
         {{$t('noOrders')}}
       </div>
        <v-col cols="12">
            <NewReceptWithItems :readOnly="true" :paymentAmount="amountToPay" :itemsToPay="selectedItems"></NewReceptWithItems>
        </v-col>
        <v-simple-table>
            <tbody>
              <tr v-for="order in orders" :key="order.uuid">
                <td class="text-left"><Time :time="order.createdAt" format="date" /></td>
                <td class="text-left">{{order.description}}</td>
                <td class="text-right"><NumberFormatter :value="order.quantity" /></td>
                <td class="text-right"><NumberFormatter :value="order.value" /></td>

                <td class="text-right">
                    <v-checkbox
                    v-model="selected"
                    label="select"
                    :value="order"
                  ></v-checkbox>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
    </v-row>
  </PageHeader>
</template>

<script>
  import PageHeader from '@/components/PageHeader';

  import Time from '@/components/Time';
  import NumberFormatter from '@/components/NumberFormatter';
  import lookups from "@/mixins/lookups";
  import NewReceptWithItems from '@/views/receipts/NewReceptWithItems';

  export default {

    components: { Time, NumberFormatter, PageHeader, NewReceptWithItems },

    props: ['customer'],

    data() {
      return {
        orders: [],
        selected: [],
        amountToPay: 0,
      };
    },
    watch: {
      customerUuid: {
        immediate: true,
        handler(to) {
          if (to) {
            console.log("fetching input orders for customer: ", to);
            this.getInputOrders();
          }
        }
      },
      selected: {
        immediate: true,
        handler(to) {
          if (to) {
            this.amountToPay = this.selected.reduce((sum, order) => sum + order.value, 0);
            console.log("selected changed: ", to, this.amountToPay);
          }
        }
      }
    },

    computed: {
      customerUuid() { return this.$route.query.uuid; },
      currency() {
        let currency = this.$store.getters.currency;
        const code =  this.$store.getters.settings.partnerCode;
        return code == "nile_ug" ? 'UGX': currency;
      },
      selectedItems() {
        return this.selected.map( order => {
          return order.uuid
        });
      }
    },

    methods: {
      async getInputOrders() {
        this.remoteLookup('getInputOrders', { customerUuid: this.customerUuid, catchedUuid: [] })
        .then( results => {
          console.log("results: ", results);
          this.orders = results;
          this.orders = this.orders.filter(item => !['deleted', 'delivered', 'confirmed'].includes(item.status))
        })    
      }
    },

    mixins: [lookups],
  }
</script>